import { UserManager, UserManagerSettings } from 'oidc-client-ts';
import GlobalConfig from './../api/GlobalConfig';

const globalConfig = GlobalConfig.val();
const websiteUrl = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;

const userManagerSettings: UserManagerSettings = {
    authority: globalConfig.IdentityApiUrl,
    client_id: globalConfig.ClientId,
    filterProtocolClaims: true,
    loadUserInfo: globalConfig.LoadUserInfo,
    silent_redirect_uri: `${websiteUrl}/silent-renew`,
    post_logout_redirect_uri: websiteUrl,
    redirect_uri: `${websiteUrl}/callback`,
    response_type: "code",
    scope: globalConfig.Scope,
    automaticSilentRenew: true,
    monitorSession: true,
    metadataUrl: globalConfig.MetadataUrl
  }

  const userManager = new UserManager(userManagerSettings);

  export default userManager;